import { useState, useEffect } from "react";
import Toggle from "react-toggle";
import { useFineSettings } from "../../utils/SettingUtils";
import Box from "../Box";
import AlertBox from "../AlertBox";
import { updateSettingByKey } from "../../api/setting";
import { useControlPermission } from "../../utils/ActionPermissionUtils";

export default function BoxSettingFine() {
  let { hasAccess } = useControlPermission();

  let { data, fetched, loading: dataLoading, getFineSetting } = useFineSettings();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [forms, setForms] = useState({
    status: "on",
    penalty_start_after_days: 0,
    penalty_amount: 0,
  });
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (fetched) {
      let defaultForms = {
        ...data.value,
      };
      setForms(defaultForms);
    }
  }, [fetched, data]);

  const sendData = async (form) => {
    setLoading(true);
    try {
      let response = await updateSettingByKey("overdue-payment-config", form);
      setAlert({ show: true, message: response.data.message, type: "success" });
      getFineSetting();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  const submitData = (event) => {
    event.preventDefault();

    let formData = {};
    formData["overdue-payment-config"] = forms;

    sendData(formData);
  };

  const toggleStatus = (value) => {
    let tempForm = { ...forms };
    tempForm.status = value;

    setForms(tempForm);
  };

  const changeValueForm = (key, value) => {
    let tempForm = { ...forms };
    tempForm[key] = value;
    setForms(tempForm);
  };

  return (
    <Box title="Setting Denda Keterlambatan" loading={dataLoading || loading}>
      <AlertBox {...alert} setAlert={setAlert} />
      <form onSubmit={(event) => submitData(event)}>
        <div className="form-group row">
          <div className="col-auto">
            <label>Denda Pelanggan</label>
          </div>
          <div className="col-auto">
            <Toggle
              checked={forms.status === "on"}
              onChange={(event) => {
                if (event.target.checked) {
                  toggleStatus("on");
                } else {
                  toggleStatus("off");
                }
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <label>Pengenaan Denda Keterlembatan (hari)</label>
          <input
            type="number"
            className="form-control"
            value={forms.penalty_start_after_days}
            onChange={(event) => changeValueForm("penalty_start_after_days", event.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Besaran denda </label>
          <input
            type="number"
            className="form-control"
            value={forms.penalty_amount}
            onChange={(event) => changeValueForm("penalty_amount", event.target.value)}
          />
        </div>
        {hasAccess("update-setting") && (
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary">Simpan Perubahan</button>
          </div>
        )}
      </form>
    </Box>
  );
}
